import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import  {fetchToken} from '../utils/fetchToken';
import Api from './ApiConfig';

export default class RestUtilities {
  static get(url) {
    console.log('GET URL [' + url + ']');
    return RestUtilities.request('GET', url);
  }

  static getBlob(url) {
    return RestUtilities.requestBlob(url);
  }

  static delete(url) {
    return RestUtilities.request('DELETE', url);
  }

  static put(url, data) {
    //console.log('PUT URL [' + url + ']');
    return RestUtilities.request('PUT', url, data);
  }

  static post(url, data, idempotency) {
    console.log('POST URL [' + url + ']');
    return RestUtilities.request('POST', url, data, idempotency);
  }

  static postNoAuth(url, data) {
    console.log('POST NO AUTH [' + url + ']');
    return RestUtilities.requestNoAuth('POST', url, data);
  }

  static postForm(url, data, idempotency) {
   // console.log('POST FORM URL [' + url + ']');
    return RestUtilities.requestFormData('POST', url, data, idempotency);
  }

static requestNoAuth(method, url, data) {
  let isBadRequest = false;
  let body = data;
    
    const headers = new Headers();
    headers.set('Accept', 'application/json');
    headers.set('Access-Control-Allow-Origin', '*');
 
    if (data) {
      headers.set('Content-Type', 'application/json');
      body = JSON.stringify(data);
    }

    return fetch(`${Api.baseUrl}/${url}`, {
      mode: 'cors',
      method,
      headers,
      body,
    })
      .then((response) => {
        if (response.status === 401) {
          // Unauthorized; redirect to sign-in
          console.log('ERROR AUTORIZACION ');
          window.localStorage.clear();
          window.location.replace('/?expired=1');
        }

        isBadRequest = response.status === 400;

        const responseContentType = response.headers.get('content-type');
        if (
          responseContentType
          && responseContentType.indexOf('application/json') !== -1
        ) {
          // isJsonResponse = true;
          return response.json();
        }
        return response.text();
      })
      .then((responseContent) => {
        const response = {
          is_error: isBadRequest,
          error_content: isBadRequest ? responseContent : null,
          content: isBadRequest ? null : responseContent,
        };
        return response;
      });
  }



  static request(method, url, data, idempotency) {

    let isBadRequest = false;
    let body = data;
    const headers = new Headers();
    //STC aqui por ahora 
    const Token =  fetchToken();

    console.log('TOKEN ES  ' + Token);
   // headers.set('Authorization', 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c3VhcmlvIjoic2lsdmlvIiwiaWQiOiI2NDM1YWY2ZDg3ZWRiMzEwMjQ0NjYzYzciLCJpYXQiOjE2ODEyMzk5MTcsImV4cCI6MTcxMjc3NTkxN30.Ex2HoJzED2CvPrbsTNvUc6XkKezIVz15MZ9elDZFczQ');

   if(Token!== null) headers.set('Authorization', Token);
    
    headers.set('Accept', 'application/json');
    headers.set('Access-Control-Allow-Origin', '*');
 

    if (data) {
      if (typeof data === 'object') {
        headers.set('Content-Type', 'application/json');
        if (idempotency) {
          headers.set('Idempotency-Key', idempotency);
        } else {
          headers.set('Idempotency-Key', uuidv4());
        }
        body = JSON.stringify(data);
        console.log(' BODY POST [' + body + ']');
      } else {
        headers.set('Content-Type', 'application/x-www-form-urlencoded');
      }
    }

    return fetch(`${Api.baseUrl}/${url}`, {
      mode: 'cors',
      method,
      headers,
      body,
    })
      .then((response) => {

      console.log('STATUS RESPONSE 2' + response.status );

        isBadRequest = response.status;

        const responseContentType = response.headers.get('content-type');
        if (
          responseContentType
          && responseContentType.indexOf('application/json') !== -1
        ) {
          // isJsonResponse = true;
          return response.json();
        }
        return response.text();
      })
      .then((responseContent) => {
        const response = {
          is_error: isBadRequest,
          error_content: isBadRequest ? responseContent : null,
          content: isBadRequest ? null : responseContent,
        };
        return response;
      });
  }

  static requestBlob(url) {
    axios(`${Api.baseUrl}/${url}`, {
      method: 'GET',
      responseType: 'blob', // Force to receive data in a Blob Format
      headers: {
        Authorization: fetchToken(),
      },
    })
      .then((response) => {
        // Create a Blob from the PDF Stream
        const file = new Blob(
          [response.data],
          { type: 'application/pdf' },
        );
        // Build a URL from the file
        const fileURL = URL.createObjectURL(file);
        // Open the URL on new Window
        window.open(fileURL);
      })
      .catch(() => {
      });
  }

  static requestFormData(method, url, data, idempotency) {
    // let isJsonResponse = false;
    let isBadRequest = false;
    const headers = new Headers();
    headers.set('Authorization', fetchToken());
    headers.set('Content-Type', 'multipart/form-data');
    if (idempotency) {
      headers.set('Idempotency-Key', idempotency);
    } else {
      headers.set('Idempotency-Key', uuidv4());
    }

    return axios(`${Api.baseUrl}/${url}`,
      {
        method: 'post',
        data,
        headers,
      })
      .then((response) => {
        if (response.status === 401 ) {
          // Unauthorized; redirect to sign-in
          console.log('ERROR AQUI  ');
          //AuthStore.removeToken();
          window.location.replace('/?expired=1');
        }

        isBadRequest = response.status;

        const responseContentType = response.headers.get('content-type');
        if (
          responseContentType
          && responseContentType.indexOf('application/json') !== -1
        ) {
          // isJsonResponse = true;
          return response.json();
        }
        return response.text();
      })
      .then((responseContent) => {
        const response = {
          is_error: isBadRequest,
          error_content: isBadRequest ? responseContent : null,
          content: isBadRequest ? null : responseContent,
        };
        return response;
      });
  }
}
